<div class="vr-section-container" >
  <img
    class="vr-image"
    src="assets/images/vr-section-image.png"
    alt="VR Experience"
  />
  <div class="vr-content">
    <sh-text size="super-header"  class="vr-header">
      VR: Redefining Patient Care, One Virtual Step at a Time.
    </sh-text>

    <sh-text size="header-1" class="vr-subtitle">
      Unlock the power of immersive learning with ExpertGuidance
    </sh-text>

    <sh-text size="body-1" class="vr-paragraph">
      Designed to elevate onboarding and training, this cutting-edge VR
      experience brings Siemens Healthineers equipment to life right at your
      fingertips. With real-time interaction and intuitive navigation,
      ExpertGuidance helps your team get up to speed faster, boosting
      confidence, efficiency, and care quality.
    </sh-text>

    <sh-text size="header-2" class="vr-bold-paragraph">
      Make every first impression count because better training leads to better
      outcomes.
    </sh-text>
    <br />

    <sh-button
      label=" Get in touch to learn more"
      size="max-content"
      onclick="document.querySelector('#contactModal').visible = true"
    ></sh-button>